module.exports = __webpack_public_path__ + "img/leftsection.8185dfc6.png";